import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-armory',
  template: `
    <p>
      armory works!
    </p>
  `,
  styles: []
})
export class ArmoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
